import React, { useState } from 'react';
import SEO from '../components/SEO';
import './FAQ.css';

function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "우천시 웨딩은 어떻게 진행하나요?",
      answer: "비가 오는 경우에도 걱정하지 마세요. 1F 홀과 2F 하우스가 있어 실내에서 편안하게 행사를 진행하실 수 있습니다. 정원 행사를 계획하신 경우, 실내 공간으로 자연스럽게 전환할 수 있도록 도와드립니다. 날씨 예보를 미리 확인하여 행사 일주일 전부터 함께 대비 계획을 세웁니다."
    },
    {
      question: "하우스웨딩은 처음인데 걱정 안 해도 되나요?",
      answer: "전혀 걱정하지 않으셔도 됩니다. 페어리가든(구 가든포에트)은 6년간 수많은 모임과 행사를 진행한 경험이 있습니다. 처음부터 끝까지 세심하게 안내해 드리며, 제휴 케이터링, 플라워, 기타 필요한 서비스들을 모두 추천해 드립니다. 여러분은 소중한 사람들과의 시간만 즐기시면 됩니다."
    },
    {
      question: "가든포에트 음식은 미리 먹어볼 수 있나요?",
      answer: "물론입니다. 포에트 시그니처인 라이브 바베큐를 포함한 메뉴 시식이 가능합니다. 예약 상담 시 시식 일정을 잡아드립니다. 실제 결혼식에서 제공될 음식을 미리 경험해보시고 결정하실 수 있습니다. 제휴 케이터링 업체들도 대부분 시식 서비스를 제공합니다."
    },
    {
      question: "주차 문제는 어떻게 해결하나요?",
      answer: "베뉴 내 전용 주차장이 있어 최대 15대까지 주차 가능합니다. 추가로 인근 공영 주차장과 거리 주차 공간도 이용하실 수 있습니다. 홍대 중심가에 위치해 있어 대중교통 접근성도 매우 좋습니다. 손님들께 주차 정보를 미리 안내해 드리면 불편함 없이 방문하실 수 있습니다."
    },
    {
      question: "애프터파티는 진행 가능한가요?",
      answer: "네, 가능합니다. 정원과 홀 모두 애프터파티에 적합한 공간입니다. 음악, 조명 등 파티 분위기를 위한 기본 장비를 제공하며, 필요시 추가 장비 대여도 도와드립니다. 정원에서의 야외 파티는 특히 분위기가 좋습니다. 대관 시간 내에서 자유롭게 진행하실 수 있습니다."
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="faq-page">
      <SEO
        title="자주 묻는 질문 | FAQ"
        description="가든포에트 하우스웨딩 FAQ. 우천시 진행, 주차, 하객 수, 예약 방법 등 자주 묻는 질문과 답변."
        path="/faq"
      />
      {/* Hero */}
      <section className="faq-hero">
        <div className="container">
          <div className="faq-hero-content fade-in">
            <h1>FAQ</h1>
            <p className="hero-subtitle">자주 묻는 질문들</p>
          </div>
        </div>
      </section>

      {/* FAQ List */}
      <section className="faq-list-section">
        <div className="container">
          <div className="faq-list fade-in">
            {faqs.map((faq, index) => (
              <div 
                key={index} 
                className={`faq-item ${openIndex === index ? 'active' : ''}`}
              >
                <button 
                  className="faq-question"
                  onClick={() => toggleFAQ(index)}
                >
                  <span className="question-text">{faq.question}</span>
                  <span className="toggle-icon">{openIndex === index ? '−' : '+'}</span>
                </button>
                <div className="faq-answer">
                  <p>{faq.answer}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="faq-cta">
        <div className="container">
          <div className="cta-content fade-in">
            <h2>더 궁금하신 점이 있으신가요?</h2>
            <p>
              언제든지 문의해 주세요.<br />
              친절하게 답변 드리겠습니다.
            </p>
            <a href="/custom" className="cta-button">Contact Us</a>
          </div>
        </div>
      </section>
    </div>
  );
}

export default FAQ;
